import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CAMPAIGN } from '@env';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CampaignsProvider {

  public campaign: Observable<any>;
  private $campaign: Subject<any>;

  constructor(private http: HttpClient, private storage: Storage ) {
    this.$campaign = new Subject<any>();
    this.campaign = this.$campaign.asObservable();
  }

  getUltimaCampaniaFinalizada(area: string, jugador: string) {
    return this.http.get(`${CAMPAIGN.ESTADISTICAS}${area}/${jugador}`).toPromise();
  }

  getCampaignActive(area: string) {
    return this.http.get(`${CAMPAIGN.ACTIVE}${area}`).toPromise();
  }

  save(campaign) {
    this.storage.set('campaign', campaign);
    if(!campaign) {
      this.storage.set('isShowingCampaign', false);
      this.storage.set('isShowingFinCampania', false);
    }
  }

  isShowing(): Promise<boolean> {
    return this.storage.get('isShowingCampaign').then((isShowingCampaign) => {
      return isShowingCampaign? true: false;
    });
  }

  hideModal() {
    this.storage.set('isShowingCampaign', true);
    this.existsCampaign();
  }

  existsCampaign(exists: boolean = true) {
    this.storage.set('existedCampaign', exists);
  }

  existedCampaign(): Promise<boolean> {
    return this.storage.get('existedCampaign').then((existedCampaign) => {
      return existedCampaign? true: false;
    });
  }

  isShowingFinCampania(): Promise<boolean> {
    return this.storage.get('isShowingFinCampania').then((isShowingFinCampania) => {
      return isShowingFinCampania? true: false;
    });
  }

  hideModalFinCampania() {
    this.storage.set('isShowingFinCampania', true);
    this.existsCampaign(false);
  }

  get(): Promise<any> {
    return this.storage.get('campaign').then((campaign) => {
      if( !campaign ) {
        return null;
      }
      return campaign;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/campaigns/campaigns.ts